import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import EducationLevelPage from './pages/EducationLevelPage';
import ExamsPage from './pages/ExamsPage';
import ResourceCategoriesPage from './pages/ResourceCategoriesPage';
import LandingPage from './pages/LandingPage';
import StudentSelection from './pages/StudentSelection';
import ContentPage from './pages/ContentPage';
import ResourceList from './pages/ResourceList';
import LoginPage from './pages/LoginPage';
import AdminAddResource from './pages/admin/AdminAddResource';
import ExamInfoPage from './pages/ExamInfoPage';
import VideoPlayerPage from './pages/VideoPlayerPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdditionalResourcesPage from './pages/AdditionalResourcesPage';
import ComingSoonPage from './pages/ComingSoonPage';
import ProtectedRoute from './components/ProtectedRoute';
import styled from '@emotion/styled';
import './App.css';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 0;
  background-color: #f5f7fa;
  position: relative;
  z-index: 1;
`;

const AppContent = () => {
  const { user } = useAuth();

  return (
    <AppContainer>
      <Header />
      <MainContent>
        <Routes>
          <Route path="/" element={<EducationLevelPage />} />
          <Route path="/exams" element={<ExamsPage />} />
          <Route path="/resource-categories/:examId" element={<ResourceCategoriesPage />} />
          <Route path="/exams/:examId/info" element={<ExamInfoPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/additional-resources" element={<AdditionalResourcesPage />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          <Route path="/levels/:levelId/grades" element={<LandingPage />} />
          <Route path="/admin" element={user ? <Navigate to="/" replace /> : <LoginPage />} />

          {/* Updated routes to include levelId */}
          <Route path="/students/:levelId/:grade" element={<StudentSelection />} />
          <Route path="/content/:levelId/:grade/:subject" element={<ContentPage />} />
          <Route
            path="/content/:levelId/:grade/:subject/:resourceType"
            element={<ResourceList />}
          />
          {/* New route for exam resources */}
          <Route
            path="/content/exams/:examId/:resourceType"
            element={<ResourceList isExam={true} />}
          />
          {/* Embedded YouTube player route */}
          <Route
            path="/watch/youtube/:videoId"
            element={<VideoPlayerPage />}
          />
          {/* Admin manage page for exam resources */}
          <Route
            path="/admin/add-resource/exams/:examId/:resourceType"
            element={
              <ProtectedRoute>
                <AdminAddResource />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/add-resource/:levelId/:grade/:subject/:resourceType"
            element={
              <ProtectedRoute>
                <AdminAddResource />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </MainContent>
      <Footer />
    </AppContainer>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
